import TitleHeader from "@/components/TitleHeader";
import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  Text,
  Input,
} from "@chakra-ui/react";
import { useState } from "react";
import BankNameList from "./bankName.json";
import BottomButton from "@/components/Button/BottomButton";

const InputItem = ({
  marginTop = "24px",
  inputMarginTop = "24px",
  label,
  smallLabel,
  value,
  onChange,
  onBlur,
  onFocus,
  onKeyDown,
}: {
  inputMarginTop?: string;
  marginTop?: string;
  label?: string;
  smallLabel?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}) => {
  return (
    <Box sx={{}}>
      {label && (
        <Text
          sx={{
            color: "#333",
            fontSize: "20px",
            fontWeight: 500,
            marginTop,
          }}
        >
          {label}
        </Text>
      )}
      {smallLabel && (
        <Text
          sx={{
            color: "#333",
            fontSize: "14px",
            fontWeight: 500,
            marginTop: "20px",
          }}
        >
          {smallLabel}
        </Text>
      )}
      <Input
        variant={"unstyled"}
        value={value}
        placeholder={"Input"}
        sx={{
          marginTop: inputMarginTop,
          "&::placeholder": {
            color: "#DEDEDE",
            fontSize: "14px",
          },
        }}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
      />
    </Box>
  );
};

const NewBankModal = ({
  isOpen,
  onClose,
  onConfirm,
  errorMessage,
  resetErrorMessage,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (payload: any) => void;
  errorMessage: string;
  resetErrorMessage: () => void;
}) => {
  const [showBankList, setShowBankList] = useState(false);
  const [filteredBanks, setFilteredBanks] = useState<string[]>([]);
  // const [bankName, setBankName] = useState("Bank of America NA");
  // const [accountNumber, setAccountNumber] = useState("325168301876");
  // const [routingNumber, setRoutingNumber] = useState("121000358");
  // const [accountOwnerName, setAccountOwnerName] = useState("Yuechen Pei");
  // const [country, setCountry] = useState("USA");
  // const [state, setState] = useState("CA");
  // const [city, setCity] = useState("Claremont");
  // const [street, setStreet] = useState("742 Amherst Avenue #1261");
  // const [postalCode, setPostalCode] = useState("91711");
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [routingNumber, setRoutingNumber] = useState("");
  const [accountOwnerName, setAccountOwnerName] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [street, setStreet] = useState("");
  const [postalCode, setPostalCode] = useState("");

  // 处理银行搜索
  const handleBankSearch = (value: string) => {
    setBankName(value);
    if (value.trim()) {
      const filtered = BankNameList.filter((bank) =>
        bank.toLowerCase().includes(value.toLowerCase())
      ).sort((a, b) => a.localeCompare(b));
      setFilteredBanks(filtered);
    }
  };

  // 选择银行
  const handleBankSelect = (bank: string) => {
    setBankName(bank);
    setShowBankList(false);
  };

  const handleConfirm = async () => {
    if (!bankName) {
      return;
    }
    if (!accountNumber) {
      return;
    }
    if (!routingNumber) {
      return;
    }
    if (!accountOwnerName) {
      return;
    }
    if (!country) {
      return;
    }
    if (!state) {
      return;
    }
    if (!city) {
      return;
    }
    if (!street) {
      return;
    }
    if (!postalCode) {
      return;
    }

    const payload = {
      currency: "usd",
      account_type: "us",
      bank_name: bankName,
      account_owner_name: accountOwnerName,
      account: {
        account_number: accountNumber,
        routing_number: routingNumber,
      },
      address: {
        street_line_1: street,
        city: city,
        state: state,
        country: country,
        postal_code: postalCode,
      },
    };

    onConfirm(payload);
  };

  console.log(showBankList, "showBankList");

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"full"} autoFocus={false}>
      <ModalContent
        sx={{
          height: "100%",
        }}
      >
        <ModalBody
          sx={{
            padding: "0",
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box sx={{ padding: "20px" }}>
            <TitleHeader
              title="Connect Bank Account"
              color="#D8762B"
              onBack={onClose}
            />
          </Box>
          <Flex
            sx={{
              padding: "0 0px 140px",
              overflowY: "auto",
              position: "relative",
              flex: 1,
            }}
            flexDir={"column"}
          >
            <Box
              sx={{
                padding: "0 20px",
              }}
            >
              <InputItem
                marginTop="10px"
                label="Bank Name"
                value={bankName}
                onChange={handleBankSearch}
                onBlur={() => {
                  setTimeout(() => {
                    setShowBankList(false);
                  }, 200);
                }}
                onFocus={() => {
                  setShowBankList(true);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    e.currentTarget.blur();
                  }
                }}
              />
            </Box>

            {showBankList && (
              <Box
                sx={{
                  flex: 1,
                  overflowY: "auto",
                  marginTop: "12px",
                  // borderTop: "1px solid rgba(0,0,0,0.25)",
                  boxShadow: "0px -2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                {filteredBanks.map((bank, index) => (
                  <Box
                    key={index}
                    sx={{
                      padding: "15px 20px",
                      height: "46px",
                      cursor: "pointer",
                      _hover: { backgroundColor: "#f5f5f5" },
                    }}
                    onClick={() => handleBankSelect(bank)}
                  >
                    {bank}
                  </Box>
                ))}
              </Box>
            )}

            {!showBankList && (
              <Box
                sx={{
                  padding: "0 20px",
                }}
              >
                <InputItem
                  label="Account Number"
                  value={accountNumber}
                  onChange={(value) => setAccountNumber(value)}
                />
                <InputItem
                  label="Routing Number"
                  value={routingNumber}
                  onChange={(value) => setRoutingNumber(value)}
                />
                <InputItem
                  label="Account Owner Name"
                  value={accountOwnerName}
                  onChange={(value) => setAccountOwnerName(value)}
                />
                <Box
                  sx={{
                    paddingBottom: "30px",
                  }}
                >
                  <InputItem
                    label="Address"
                    smallLabel="Country"
                    value={country}
                    onChange={(value) => setCountry(value)}
                    inputMarginTop="5px"
                  />
                  <Flex>
                    <InputItem
                      smallLabel="State"
                      value={state}
                      onChange={(value) => setState(value)}
                      inputMarginTop="5px"
                    />
                    <InputItem
                      smallLabel="City"
                      value={city}
                      onChange={(value) => setCity(value)}
                      inputMarginTop="5px"
                    />
                  </Flex>

                  <InputItem
                    smallLabel="Street"
                    value={street}
                    onChange={(value) => setStreet(value)}
                    inputMarginTop="5px"
                  />
                  <InputItem
                    smallLabel="Postal Code"
                    value={postalCode}
                    onChange={(value) => setPostalCode(value)}
                    inputMarginTop="5px"
                  />
                </Box>
              </Box>
            )}
            <BottomButton
              onClick={handleConfirm}
              errorMessage={errorMessage}
              onCloseError={resetErrorMessage}
            >
              Confirm
            </BottomButton>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default NewBankModal;
